import { render, staticRenderFns } from "./gridResultados.vue?vue&type=template&id=2c3b1f1c"
import script from "./gridResultados.ts?vue&type=script&lang=js&external"
export * from "./gridResultados.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3b1f1c')) {
      api.createRecord('2c3b1f1c', component.options)
    } else {
      api.reload('2c3b1f1c', component.options)
    }
    module.hot.accept("./gridResultados.vue?vue&type=template&id=2c3b1f1c", function () {
      api.rerender('2c3b1f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/fichaTecnica/gridResultados.vue"
export default component.exports